export default "__VITE_ASSET__73360cb2__"